import React, { useMemo } from "react";
import { Pressable } from "react-native";
import { Thumbnail } from "@lookiero/aurora";
import { Text } from "@lookiero/sty-psp-ui";
import { AspectRatioView } from "@lookiero/sty-psp-ui";
import { AnimatedChecked } from "../animatedChecked/AnimatedChecked";
import { style as optionImageStyle } from "./OptionImage.style";
const OptionImage = ({ checked, disabled, imageResizeMode, src, srcSet, title, value, style: customStyle, icon, text, aspectRatio, testID, onChange, }) => {
    const style = useMemo(() => optionImageStyle(), []);
    return (React.createElement(React.Fragment, null,
        React.createElement(AspectRatioView, { aspectRatio: aspectRatio, style: style.aspectRatioView },
            React.createElement(Pressable, { style: [style.pressable, customStyle?.container], testID: testID, onPress: !disabled && onChange ? () => onChange(value) : undefined },
                React.createElement(Thumbnail, { src,
                    srcSet,
                    resizeMode: imageResizeMode,
                    style: [style.image, customStyle?.image] }),
                React.createElement(Text, { style: { display: "none" } }, title),
                React.createElement(AnimatedChecked, { checked: checked, icon: icon, style: {
                        container: customStyle?.container,
                        iconContainer: customStyle?.icon?.iconContainer,
                        icon: customStyle?.icon?.icon,
                    } }))),
        text && (React.createElement(Text, { ellipsizeMode: "tail", level: 2, style: style.text, variant: "detail" }, text))));
};
export { OptionImage };
